module.exports = __webpack_public_path__ + "static/media/build-collection-for-you-mobile.292642ca.svg";